(ns app.front.view.property.util
  (:require [core.front.href :as href]
            [core.util.util :as util]
            [potpuri.core :as p]))

(defn property-link
  "Workspace-ref is used in creating the breadcrumb to return to the workspace.
  Complaint-ref for returning to complaint detail view.
  Property-ref (a property's `:db/id`) for returning to the property that linked here, e.g. when
  navigating between related properties."
  [{:property/keys [verified-id id-domain]
    db-id          :db/id}
   & [{:keys [workspace-ref
              complaint-ref
              property-ref
              modal]}]]
  (let [query-params (->> (util/mmap workspace-ref complaint-ref property-ref modal)
                          (p/remove-vals nil?))]
    (if (and verified-id id-domain)
      (href/href :view/property-by-id (util/mmap verified-id id-domain) query-params)
      (href/href :view/property (util/mmap db-id) query-params))))
